module.exports = __webpack_public_path__ + "img/greentick.d9313667.svg";